"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Block = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _container = _interopRequireDefault(require("../container"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var styles = function styles(theme) {
  return {
    root: {
      padding: theme.spacing(6, 0)
    },
    container: {}
  };
};
/**
 * The Block component is used to create a distinct section on the page.  By default the Block component has the following styles applied:
 *
 * - 6 units (48px) of padding on the top / bottom of the block
 * - fluid width to fill the full width of the page (or parent element)
 * - content within the block follows the constraints of the Container component
 *
 * The root Block component is a [Material UI box](https://material-ui.com/components/box/) component, so all [box props](https://material-ui.com/components/box/#api) and [style props](https://material-ui.com/system/basics/#all-inclusive) are available.
 */


var Block = function Block(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      children = _ref.children,
      ContainerProps = _ref.ContainerProps,
      props = _objectWithoutProperties(_ref, ["classes", "className", "children", "ContainerProps"]);

  return /*#__PURE__*/_react["default"].createElement(_core.Box, _extends({
    className: (0, _clsx["default"])(classes.root, className)
  }, props), /*#__PURE__*/_react["default"].createElement(_container["default"], _extends({
    className: (0, _clsx["default"])(classes.container)
  }, ContainerProps), children));
};

exports.Block = Block;
Block.defaultProps = {
  ContainerProps: {}
};
Block.propTypes = {
  /**
   * Object with class name overrides (valid keys: `root`, `container`)
   */
  classes: _propTypes["default"].object,

  /**
   * Props to pass to the inner Container component
   */
  ContainerProps: _propTypes["default"].object
};
Block.__docgenInfo = {
  "description": "The Block component is used to create a distinct section on the page.  By default the Block component has the following styles applied:\n\n- 6 units (48px) of padding on the top / bottom of the block\n- fluid width to fill the full width of the page (or parent element)\n- content within the block follows the constraints of the Container component\n\nThe root Block component is a [Material UI box](https://material-ui.com/components/box/) component, so all [box props](https://material-ui.com/components/box/#api) and [style props](https://material-ui.com/system/basics/#all-inclusive) are available.",
  "methods": [],
  "displayName": "Block",
  "props": {
    "ContainerProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "Props to pass to the inner Container component"
    },
    "classes": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "Object with class name overrides (valid keys: `root`, `container`)"
    }
  }
};
var exportComponent = (0, _core.withStyles)(styles)(Block); // copy static props for storybook

if (process.env.NODE_ENV !== "production") {
  exportComponent.displayName = Block.displayName;
  exportComponent.propTypes = Block.propTypes;
  exportComponent.defaultProps = Block.defaultProps;
}

var _default = exportComponent;
exports["default"] = _default;